import a,{useState as y}from"react";import{forwardRef as F,createElement as M}from"react";var g=t=>t.replace(/([a-z0-9])([A-Z])/g,"$1-$2").toLowerCase(),B=t=>t.replace(/^([A-Z])|[\s-_]+(\w)/g,(e,u,o)=>o?o.toUpperCase():u.toLowerCase()),C=t=>{let e=B(t);return e.charAt(0).toUpperCase()+e.slice(1)},L=(...t)=>t.filter((e,u,o)=>!!e&&e.trim()!==""&&o.indexOf(e)===u).join(" ").trim(),S=t=>{for(let e in t)if(e.startsWith("aria-")||e==="role"||e==="title")return!0};import{forwardRef as D,createElement as w}from"react";var h={xmlns:"http://www.w3.org/2000/svg",width:24,height:24,viewBox:"0 0 24 24",fill:"none",stroke:"currentColor",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"};var k=D(({color:t="currentColor",size:e=24,strokeWidth:u=2,absoluteStrokeWidth:o,className:f="",children:d,iconNode:m,...r},i)=>w("svg",{ref:i,...h,width:e,height:e,stroke:t,strokeWidth:o?Number(u)*24/Number(e):u,className:L("lucide",f),...!d&&!S(r)&&{"aria-hidden":"true"},...r},[...m.map(([I,x])=>w(I,x)),...Array.isArray(d)?d:[d]]));var s=(t,e)=>{let u=F(({className:o,...f},d)=>M(k,{ref:d,iconNode:e,className:L(`lucide-${g(C(t))}`,`lucide-${t}`,o),...f}));return u.displayName=C(t),u};var R=[["path",{d:"m6 9 6 6 6-6",key:"qrunsl"}]],c=s("chevron-down",R);var q=[["rect",{width:"14",height:"14",x:"8",y:"8",rx:"2",ry:"2",key:"17jyea"}],["path",{d:"M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",key:"zix9uf"}]],n=s("copy",q);var T=[["circle",{cx:"12",cy:"12",r:"10",key:"1mglay"}],["path",{d:"M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20",key:"13o1zl"}],["path",{d:"M2 12h20",key:"9i4pu4"}]],p=s("globe",T);var b=[{code:"DE",name:"Deutsch",flag:"https://flagcdn.com/w20/de.png"},{code:"EN",name:"English",flag:"https://flagcdn.com/w20/gb.png"},{code:"FR",name:"Fran\xE7ais",flag:"https://flagcdn.com/w20/fr.png"},{code:"ES",name:"Espa\xF1ol",flag:"https://flagcdn.com/w20/es.png"},{code:"ZH",name:"\u4E2D\u6587",flag:"https://flagcdn.com/w20/cn.png"}];function U({logoSrc:t="https://uploadthingy.s3.us-west-1.amazonaws.com/tXtrQ38XxwUBTwmzoNN8ZL/Prospeum_Logo_White_SVG.svg",logoAlt:e="Prospeum Logo",onCopyLink:u,selectedLanguage:o="DE",languages:f=b,onLanguageChange:d,"data-id":m}){let[r,i]=y(!1),I=f.find(l=>l.code===o)||f[0],x=()=>{u?u():navigator.clipboard.writeText(window.location.href)},P=l=>{i(!1),d&&d(l)};return a.createElement("div",{"data-id":m,className:"bg-[#0e5680] text-white px-9 py-3 flex items-center justify-between w-full text-xs font-roboto"},a.createElement("div",{className:"flex items-center"},a.createElement("img",{src:t,alt:e,className:"h-6 w-auto"})),a.createElement("div",{className:"flex items-center gap-4"},a.createElement("button",{onClick:x,className:`
            bg-gray-200 text-gray-800 border border-gray-200 rounded
            px-3 py-1.5 text-xs font-normal
            hover:bg-gray-300 transition-colors duration-150
            flex items-center gap-1
          `},a.createElement(n,{size:12}),"Copy Magic Link"),a.createElement("div",{className:"relative"},a.createElement("button",{onClick:()=>i(!r),className:`
              flex items-center gap-1 px-0 py-1.5 text-white
              hover:text-gray-300 transition-colors duration-100
              relative z-10
            `,"aria-haspopup":"true","aria-expanded":r},a.createElement(p,{size:18,className:"text-white"}),a.createElement("span",{className:"ml-1 text-xs text-white"},I.name),a.createElement(c,{size:12,className:"text-gray-400"})),r&&a.createElement(a.Fragment,null,a.createElement("div",{className:"fixed inset-0 z-10",onClick:()=>i(!1)}),a.createElement("div",{className:`
                absolute right-0 top-full mt-1.5 z-20
                bg-white border border-gray-200 rounded shadow-lg
                min-w-[150px] py-1.5
              `},a.createElement("ul",{className:"min-w-[150px]"},f.map(l=>a.createElement("li",{key:l.code},a.createElement("button",{onClick:()=>P(l.code),className:`
                          w-full text-left px-2.5 py-1.5 text-xs
                          text-gray-700 hover:bg-gray-50
                          flex items-center gap-1.5
                          transition-colors duration-150
                        `},a.createElement("img",{src:l.flag,alt:`${l.code} Flag`,className:"w-4 h-3 object-cover border-0",onError:A=>{A.currentTarget.style.display="none"}}),a.createElement("span",null,l.code))))))))))}export{U as HeaderBar};
/*! Bundled license information:

lucide-react/dist/esm/shared/src/utils.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/defaultAttributes.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/Icon.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/createLucideIcon.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/chevron-down.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/copy.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/globe.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/lucide-react.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)
*/
//# sourceMappingURL=index.js.map
